<template>
    <div class="aboutUs">
        <div class="banner" >
        </div>
        <div class="silei">
            <template>
                <el-tabs v-model="activeName" class="tabs">
                    <el-tab-pane label="企业简介" name="first" class="first">
                        <p class="p1">企业简介</p>
                        <p class="pp p2">南京壹宝通信息技术有限公司成立于2015年，公司总部设立在江苏省南京市，在徐州市、苏州市设立有分公司。</p>
                        <p class="pp p3">壹宝通是一家致力于为政务、企业、医疗、教育提供一站式数字化管理方案以及办公自动化培训等服务的互联网公司。公司以“让沟通更简单，让工作更高效”为理念专注于钉钉平台办公数字化推广，根据客户需求量身定制，助力企业降本增效。</p>
                        <p class="pp p4">壹宝通公司是钉钉在南京本地化运营服务中心，“迭代格局，共创未来”，
                            公司在不断优化主营业务的基础上会不断的推进信息化建设和技术创新。
                            公司拥有阿里钉钉全国资历最深的一批部署咨询专家，拥有专业的服务能力和企业解决方案能力。
                            公司先后服务了建邺区政府、高新区政府、江北新区政府、秦淮区政府、麒麟街道、淳化街道、秣陵街道等100多个政府单位，
                            中国信保、徐州联通、惠和建筑、中北的士、欧蓓莎公司、南京公用发展公司、天环科技，苏州三川、金陵中学、磐龙建设公司等3000多知名企业或教育机构，是一家正在高速发展的科技公司。</p>
                        <ul class="ul1">
                            <li>
                                <div class="shuzi">
                                    <span class="span1">500</span><span class="span2">+</span>
                                </div>
                                <p>政企客户</p>
                                <p>涵盖众多政府和知名企业</p>
                            </li>
                            <li>
                                <div class="shuzi">
                                    <span class="span1">200</span><span class="span2">+</span>
                                </div>
                                <p>多个场景应用</p>
                                <p>覆盖多个细分行业需求</p>
                            </li>
                            <li>
                                <div class="shuzi">
                                    <span class="span1">80</span><span class="span2">+</span>
                                </div>
                                <p>多名服务人员</p>
                                <p>全国提供专业服务</p>
                            </li>
                            <li>
                                <div class="shuzi">
                                    <span class="span1">30</span><span class="span2">+</span>
                                </div>
                                <p>多名研发专家</p>
                                <p>打造强大智慧办公产品</p>
                            </li>
                        </ul>
                        <ul class="ul2">
                            <li class="li1">
                                <img src="http://img601.yun300.cn/img/15o0.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                                <p class="p-ul2-1">企业使命</p>
                                <p class="p-ul2-2">帮助所有企业和组织实现数字化管理</p>
                            </li>
                            <li class="li2">
                                <img src="	http://img601.yun300.cn/img/15k.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                                <p class="p-ul2-1">企业愿景</p>
                                <p class="p-ul2-2">成为企业数字化管理创新建设的引领者</p>
                            </li>
                            <li class="li3">
                                <img src="http://img601.yun300.cn/img/15co.png?tenantId=214689&viewType=1&k=1651226704000" alt="" loading="lazy">
                                <p class="p-ul2-1">企业价值观</p>
                                <p class="p-ul2-2">诚信 担当 共赢</p>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="发展历程" name="second" class="second">
                        <p class="p1">发展历程</p>
                        <ul>
                            <li >
                                <div class="left">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2015</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">公司成立</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">南京壹宝通信息技术有限公司成立</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">初识阿里</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">职场黑马</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">2016年度“南京优秀服务商”</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">拓展支付宝城市业务</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2016</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2017</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">沉淀市场</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">All in “运营”</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">合并南京市场前5名服务商</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">拥抱变化</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">加入钉钉 战略转型</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">启明星TOP1</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2018</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2019</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">锋芒乍现</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">All in “DAU”   布局政务+教育</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">苏皖城市服务商KPI完成率第一</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:20px;">绝处逢生</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">全员抗疫  复工首战告捷</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">政务+教育+企业    商业化“结果”</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2020</p>
                                </div>
                            </li>
                            <li >
                                <div class="left">
                                    <p style="font-size:22px;font-family:georgia,serif;color:#000000;">2021</p>
                                </div>
                                <div class="center">
                                    <div class="element4"></div>
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <p style="color:#0089ff;font-family:微软雅黑;font-size:16px;line-height:21px;">开疆拓土</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">数字区县 TB核心服务商</p>
                                    <p style="font-family:微软雅黑;font-size:16px;line-height:26px;">疫情防控平台</p>
                                </div>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="荣誉资质" name="third" class="third">
                        <p class="p1">荣誉资质</p>
                        <div class="no1">系统软件认证证书</div>
                        <ul class="jiangzhuang">
                            <li>
                                <img src="./imgs/caigou.jpg" alt="" loading="lazy">
                                <p>采购管理软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/dangjian.jpg" alt="" loading="lazy">
                                <p>党建团建管理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/dishi.jpg" alt="" loading="lazy">
                                <p>的士运营管理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/huitong.png" alt="" loading="lazy">
                                <p>慧通智慧园区软件系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/shehui.jpg" alt="" loading="lazy">
                                <p>社会治理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/shouhuo.jpg" alt="" loading="lazy">
                                <p>售后工单管理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/oa.jpg" alt="" loading="lazy">
                                <p>智慧OA系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/zhihuiyuanqu.jpg" alt="" loading="lazy">
                                <p>智慧园区系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/xiaoyuan.jpg" alt="" loading="lazy">
                                <p>智慧校园管理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/kaoqin.jpg" alt="" loading="lazy">
                                <p>考勤系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/toubiao.jpg" alt="" loading="lazy">
                                <p>项目招投标管理系统软件证书</p>
                            </li>
                            <li>
                                <img src="./imgs/ruanjian.jpg" alt="" loading="lazy">
                                <p>软件企业证书</p>
                            </li>
                            <!-- <li>
                                <img src="./imgs/chiyuan.jpg" alt="">
                                <p>驰远授权证书～星级合伙人</p>
                            </li>
                            <li>
                                <img src="./imgs/iso.jpg" alt="">
                                <p>ISO质量认证证书</p>
                            </li> -->
                        </ul>
                        <div class="no1">软件企业评估</div>
                        <ul class="jiangzhuang2">
                            <li>
                                <img src="./imgs/ruanjian.jpg" alt="" loading="lazy">
                                <p>软件企业证书</p>
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </template>
        </div>

    </div>
</template>

<script>
export default {
   data () {
       return {
           activeName: 'first',
       }
   },
   methods: {

   }
}
</script>
<style lang='less' scoped>
    .banner{
        width:100% ;
        height: 450px;
        background-image: url("./banner-pc-img/gywm_1920337.5@1x-tuya.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        position: relative;
        .center-box{
            position: absolute;
            width: 500px;
            height: 202px;
            top: 100px;
            left: 400px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .p1{
                font-size: 45px;
                letter-spacing: 1.5px;
                color: #fff;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            }
            .p2{
                font-size: 30px;
                color: #fff;
                letter-spacing: 1.5px;
                margin-top: 10px;
            }
        }
    }
    .tabs{
        width: 90%;
        margin:0 auto;
        margin-bottom: 30px;
        /deep/ .el-tabs__nav-scroll{
            height: 86px;
        }
        /deep/ .el-tabs__item{
            height: 86px;
            line-height: 86px;
        }
        /deep/ .el-tabs__nav{
            width: 100%!important;
            display: flex!important;
            justify-content: space-evenly;
        }
        /deep/ .el-tabs__active-bar{
            display: none!important;
        }
        /deep/.el-tabs__nav-wrap::after{
            background-color: rgba(245, 245, 245, 1)!important;
            height: 1px!important;
        }

        /deep/ .el-tabs__item{
            font-size: 25px!important;
            letter-spacing: 2px;
        }

    }
    .first{
        margin-top: 20px;
        text-align: left;
       .p1{
            width: 100%;
            line-height: 43px;
            font-family: 微软雅黑;
            margin-bottom: 30px;
            font-size: 35px;
            color: #000;
            text-align: center;
       }
       .pp{
           width: 100%;
           line-height: 40px;
           font-size: 22px;
           font-family: 微软雅黑;
           color: #595959;
           text-indent: 40px;
           letter-spacing: 1px;
       }
       .p2,.p3,.p4{
           margin-bottom: 16px;
       }
       ul.ul1{
           width: 100%;
           display: flex;
           justify-content: space-around;
           margin-top: 20px;
           padding: 20px;
           li{
               width: 18%;
               padding: 20px;
               display: flex;
               flex-direction: column;
               justify-content: center;
               align-items: center;
               .shuzi{
                   width: 100%;
                   text-align: center;
                   .span1{
                       font-size: 56px;
                       color:#0089ff;
                   }
                   .span2{
                       font-size: 28px;
                       color:#0089ff;
                   }
               }
               p{
                   width: 100%;
                   text-align: center;
                   line-height: 22px;
                   color: #595959;
                   font-size: 22px;
                   font-family:微软雅黑;
                   margin-top: 15px;
               }
           }
       }
       ul.ul2{
           width: 100%;
        //    height: 205px;
           display: flex;
           justify-content: space-around;
           align-items: center;
           margin-top: 40px;
           padding-bottom: 30px;
           li{
               width: 28%;
               padding: 40px;
               text-align: center;
               display: flex;
               flex-direction: column;
               justify-content: space-evenly;
               align-items: center;
               border-radius: 6px;
               img{
                   width: 80px;
                   height: 80px;
               }
               .p-ul2-1{
                   width: 100%;
                   line-height: 28px;
                   font-weight: 700;
                   font-size: 22px;
                   margin: 0;
                   color:#FFFFFF;
                   font-family: 微软雅黑;
                   margin-top: 20px;
                   margin-bottom: 20px;
                   letter-spacing: 2px;
               }
               .p-ul2-2{
                   width: 100%;
                   font-size: 20px;
                   margin: 0;
                   color:#FFFFFF;
                   font-family: 微软雅黑;
                   letter-spacing: 1.5px;
               }
           }
           li.li1{
               background-color: rgba(50, 150, 250, 1);
           }
           li.li2{
               background-color: rgba(138, 113, 242, 1);
           }
           li.li3{
               background-color: rgba(242, 170, 85, 1);
           }
       }
    }
.second{
    margin-top: 20px;
    text-align: left;
    .p1{
        width: 100%;
        line-height: 43px;
        font-family: 微软雅黑;
        margin-bottom: 30px;
        font-size: 32px;
        color: #000;
        text-align: center;
    }
    ul{
        width: 100%;
        li{
            width: 100%;
            height: 160px;
            margin-bottom: 20px;
            transition: all 0.3s linear;
            padding-top: 10px;
            .left{
                width: 48%;
                height: 100%;
                text-align: right;
                float: left;
            }
            .right{
                width: 48%;
                text-align: left;
                font-size:22px;
                font-family:georgia,serif;
                color:#000000;
                float: left;
            }
            .center{
                width: 4%;
                height: 100%;
                text-align: left;
                font-size:22px;
                font-family:georgia,serif;
                color:#000000;
                float: left;
                .element4{
                    width: 20px;
                    height: 20px;
                    background-color: #fff;
                    border-radius: 50%;
                    box-shadow: 0 0 0 5px #ff9900 ;
                    margin: auto;
                    margin-top: 5px;
                }
                .line{
                    width: 1px;
                    height: 100px;
                    background-color: #ccc;
                    margin: 10px auto;
                }
            }
        }
        li:nth-child(2n){
            background-color: rgba(246, 246, 246, 1);
        }
        li:nth-child(2n-1){
            background-color: #fff;
        }
        li:hover{
            box-shadow: rgb(0 0 0 / 20%) 10px 10px 20px 0px;
            z-index: 9;
        }
    }

}
.third{
    margin-top: 20px;
    text-align: left;
    .p1{
        width: 100%;
        height: 43px;
        line-height: 43px;
        font-family: 微软雅黑;
        margin-bottom: 30px;
        font-size: 32px;
        color: #000;
        text-align: center;
    }
    .no1{
        width: 100%;
        height: 46px;
        background-color: rgba(245, 245, 245, 1);
        line-height: 46px;
        color: #000;
        font-weight: bold;
        font-size: 20px;
        padding-left: 20px;
    }
    .jiangzhuang,.jiangzhuang2{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        li{
            width: 295px;
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            margin-left: 10px;
            img{
                width: 295px;
                height: 400px;
            }
            p{
                line-height: 46px;
                font-size: 22px;
                color:#696969;
                padding-left: 20px;
            }
        }
    }
    .jiangzhuang2{
        li{
            width: 400px;
            height: 336px;
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            margin-left: 10px;
            img{
                width: 400px;
                height: 290px;
            }
        }
    }
}
</style>
